import Swiper from "swiper"

import { EffectFade, Navigation, Pagination, Thumbs } from "swiper/modules"

import "swiper/css"
import "swiper/css/effect-fade"
import { SwiperOptions } from "swiper/types/swiper-options"

type CarouselProps = {
  mode: "card" | "fade" | "news" | ""
}

const defaultConfig: SwiperOptions = {
  autoHeight: true,
  centeredSlides: true,
  slidesPerView: 1,
  spaceBetween: 132,
}

const cardConfig: SwiperOptions = {
  centeredSlides: false,
  slidesPerView: 1,
  spaceBetween: 24,
  breakpoints: {
    572: {
      slidesPerView: 1.5,
    },
    768: {
      slidesPerView: 2,
    },
    984: {
      slidesPerView: 2.5,
    },
    1200: {
      slidesPerView: 3,
    },
  },
}

function carousel(el: HTMLElement, props: CarouselProps) {
  const carouselMain = el.querySelector<HTMLDivElement>(".carousel-main.swiper")
  const carouselTabs = el.querySelector<HTMLDivElement>(
    ".carousel-tabs>.swiper",
  )
  const carouselNav = el.querySelector<HTMLDivElement>(".carousel-navigation")
  const carouselPagination = el.querySelector<HTMLDivElement>(
    ".carousel-pagination",
  )

  if (!carouselMain) {
    return
  }

  let tabs

  if (carouselTabs) {
    tabs = new Swiper(carouselTabs, {
      slidesPerView: "auto",
      spaceBetween: 24,
      watchSlidesProgress: true,
      breakpoints: {
        1199: {
          spaceBetween: 36,
        },
      },
    })
  }

  const mode = props.mode

  const baseConfig =
    mode === "card"
      ? cardConfig
      : mode === "news"
        ? { ...defaultConfig, spaceBetween: 0 }
        : defaultConfig

  const carouselSwiper = new Swiper(carouselMain, {
    ...baseConfig,
    setWrapperSize: true,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    navigation: carouselNav
      ? {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        }
      : undefined,
    thumbs: tabs ? { swiper: tabs } : undefined,
    effect: mode === "fade" ? "fade" : undefined,
    fadeEffect: {
      crossFade: true,
    },
    on: {
      init: function () {
        el.classList.add("opacity-100")
      },
    },
    modules: carouselNav
      ? [Pagination, Thumbs, EffectFade, Navigation]
      : [Pagination, Thumbs, EffectFade],
  })

  if (carouselSwiper.isLocked) {
    carouselNav?.classList.add("hidden")
    carouselPagination?.classList.add("hidden")
  }

  carouselSwiper.on("lock", () => {
    carouselNav?.classList.add("hidden")
    carouselPagination?.classList.add("hidden")
  })

  carouselSwiper.on("unlock", () => {
    carouselNav?.classList.remove("hidden")
    carouselPagination?.classList.remove("hidden")
  })
}
export default carousel
